import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {setCurrentRiddleRange, updateScrollPosition} from "../../ducks/duck-screen";
import {getRiddlesFromRange, initializeStatsInUnlockedLevel, setCurrentLevel, unlockLevel} from "../../ducks/duck-game";

import PlayScreen from "./play-screen";

function PlayScreenContainer(props) {
	return (
		<PlayScreen {...props}/>
	);
}

PlayScreenContainer.propTypes = {
	isDatabaseResetting: PropTypes.bool.isRequired,
	gameType: PropTypes.string.isRequired,
	gameTypeCollectedRiddles: PropTypes.number.isRequired,
	isSound: PropTypes.bool.isRequired,
	isUnlocking: PropTypes.bool.isRequired,

	levelList: PropTypes.object.isRequired,
	scrollPositions: PropTypes.object.isRequired,
	currentExtraLevel: PropTypes.object.isRequired,


	push: PropTypes.func.isRequired,
	setCurrentRiddleRange: PropTypes.func.isRequired,
	getRiddlesFromRange: PropTypes.func.isRequired,
	updateScrollPosition: PropTypes.func.isRequired,
	unlockLevel: PropTypes.func.isRequired,
	initializeStatsInUnlockedLevel: PropTypes.func.isRequired,
};

// export default PlayScreenContainer;
function mapStateToProps(state) {
	const gameType = state.gameReducer.gameType;
	const settings = state.userReducer.settings;

	let gameTypeCollectedRiddles = state.gameReducer.collectedRiddlesForGameType || {};
	if(gameTypeCollectedRiddles[gameType]){
		gameTypeCollectedRiddles = gameTypeCollectedRiddles[gameType]
	} else {
		gameTypeCollectedRiddles = 0
	}

	let isSound = false;
	if(settings && settings.isSound){
		isSound = true;
	}

	let isVibrate = false;
	if(settings && settings.isVibrate){
		isVibrate = true;
	}

	return {
		levelList : state.gameReducer.levelList,
		// user: state.userReducer,
		gameType,
		gameTypeCollectedRiddles,
		scrollPositions: state.screenReducer.scrollPositions,
		currentExtraLevel: state.gameReducer.currentExtraLevel,
		isDatabaseResetting: state.gameReducer.isDatabaseResetting,
		isUnlocking: state.gameReducer.isUnlocking,
		isSound,
		isVibrate
	};
}

export default connect(
	mapStateToProps,
	{ setCurrentRiddleRange,
		getRiddlesFromRange,
		updateScrollPosition,
		setCurrentLevel,
		unlockLevel,
		initializeStatsInUnlockedLevel
	}
	)(PlayScreenContainer);
